"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NextErrorCode = void 0;
var NextErrorCode;
(function (NextErrorCode) {
    NextErrorCode[NextErrorCode["CREATE_ORDER_FAILED"] = 100] = "CREATE_ORDER_FAILED";
    // ---- Calculation error codes
    NextErrorCode[NextErrorCode["CALCULATION_ADD_ERROR"] = 101] = "CALCULATION_ADD_ERROR";
    NextErrorCode[NextErrorCode["CALCULATION_REMOVE_ERROR"] = 102] = "CALCULATION_REMOVE_ERROR";
    NextErrorCode[NextErrorCode["CHOOSE_OFFER_ERROR"] = 103] = "CHOOSE_OFFER_ERROR";
    // ---- Vehicle Error Codes
    NextErrorCode[NextErrorCode["VEHICLE_ADD_ERROR"] = 104] = "VEHICLE_ADD_ERROR";
    NextErrorCode[NextErrorCode["VEHICLE_REMOVE_ERROR"] = 105] = "VEHICLE_REMOVE_ERROR";
    NextErrorCode[NextErrorCode["VEHICLE_UPDATE_ERROR"] = 106] = "VEHICLE_UPDATE_ERROR";
    // ---- Toggle vehicle accessories failure
    NextErrorCode[NextErrorCode["VEHICLE_ACCESSORY_TOGGLE_ERROR"] = 106] = "VEHICLE_ACCESSORY_TOGGLE_ERROR";
    // ---- Customer error
    NextErrorCode[NextErrorCode["CUSTOMER_ADD_ERROR"] = 107] = "CUSTOMER_ADD_ERROR";
    // Sign contract
    NextErrorCode[NextErrorCode["SIGN_CONTRACT_ERROR"] = 109] = "SIGN_CONTRACT_ERROR";
})(NextErrorCode = exports.NextErrorCode || (exports.NextErrorCode = {}));
//# sourceMappingURL=errorEnums.js.map